import {eventBus} from "../../../event-bus";
import React, {useEffect, useState} from "react";
import {Typography, Box} from "@mui/material";
import {getDistributorTopData} from "../../api/get-distributor-data";
import {useTranslation} from 'react-i18next';
import TableContainerComp from "../../../components/table-container-comp";
import {TabPanel} from "../../../components/tab-panel-comp";
import ProductDetailsDialog from "../../../dialog/product-details-dialog";
import GlowingMessage from "../../../errors/glowing-message";

const TabTopProducts = ({tabValue, tenantId, tenantType}) => {
    const [detailsDialogOpen, setDetailsDialogOpen] = useState(false)
    const [selectedProductForDetails, setSelectedProductForDetails] = useState(null)
    const [data, setData] = useState([]);
    const [message, setMessage] = useState("");
    const {t} = useTranslation();

    const fetchData = async () => {
        try {
            const result = await getDistributorTopData({tenantId});
            setData(result);
        } catch (error) {
            setMessage(error.response?.data?.message || "Failed to get product Table.")
        }
    };

    const handleProductNameClick = (product) => {
        setSelectedProductForDetails(product)
        setDetailsDialogOpen(true)
    }

    const handleDetailsDialogClose = () => {
        fetchData()
            .then(r => console.log(r))
        setDetailsDialogOpen(false)
    }

    useEffect(() => {
        fetchData().then(r => console.log(r));
    }, [t]);

    useEffect(() => {
        const handleRefresh = () => {
            fetchData().then(r => console.log(r))
        }
        eventBus.on("refreshProductsData", handleRefresh)
        return () => {
            // Clean up when component unmounts
            eventBus.off("refreshProductsData", handleRefresh)
}
    }, [])

    return (
        <>
            <GlowingMessage message={message} onClose={() => setMessage("")}/>
            <TabPanel value={tabValue} index={2} typePanel="distributor">
                <Box sx={{padding: 2}}>
                    <Typography variant="h6" sx={{marginBottom: 2}}>
                        🛒 {t("TopDiscountedProducts")}
                    </Typography>
                    <TableContainerComp rows={data}
                                        onProductNameClick={handleProductNameClick}
                                        isDistributor={false}/>
                    <ProductDetailsDialog
                        product={selectedProductForDetails}
                        onClose={handleDetailsDialogClose}
                        open={detailsDialogOpen}
                        tenantType={tenantType}
                    />
                </Box>
            </TabPanel>
        </>
    );
};

export default TabTopProducts;
